module.exports = "/interactives/anyang/life-in-the-city/_next/static/images/artifact-5a9aba9d5712f25b0f5476d97df31bb8.png";